"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRelease = exports.fetchReleasesIfNeeded = exports.ADD_RELEASE = exports.FETCH_RELEASES = void 0;
var utils_1 = require("../../utils");
exports.FETCH_RELEASES = (0, utils_1.networkActionTypes)("FETCH_RELEASES");
exports.ADD_RELEASE = (0, utils_1.networkActionTypes)("ADD_RELEASE");
var fetchReleases = (0, utils_1.networkAction)(exports.FETCH_RELEASES, "/releases");
exports.fetchReleasesIfNeeded = (0, utils_1.makeIfNeededAction)(fetchReleases, "releases");
var _addRelease = (0, utils_1.networkAction)(exports.ADD_RELEASE, "/releases", "POST");
var addRelease = function (body, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (state.releases.isFetching || state.releases.isAdding || state.releases.isUpdating)
            return;
        return dispatch(_addRelease(body, {}, accessToken));
    };
};
exports.addRelease = addRelease;
